import { lazy } from "react"
import { useLocation } from "react-router"
import { ErrorBoundary } from "react-error-boundary"

import UnexpectedError from "./unexpected-error"

const NotFound = lazy(() => import("./404"))

const ErrorBoundaary: React.FC<React.PropsWithChildren> = ({ children }) => {
  const location = useLocation()

  return (
    <ErrorBoundary
      resetKeys={[location.key]}
      fallbackRender={({ error, resetErrorBoundary }) => {
        if (error.name === "404") return <NotFound />
        return <UnexpectedError reset={resetErrorBoundary} />
      }}
      children={children}
    />
  )
}

export default ErrorBoundaary
